var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex card" }, [
    _vm.data_updated
      ? _c(
          "div",
          { staticClass: "p-1" },
          [
            _c("vue-apex-charts", {
              attrs: {
                width: "100%",
                height: "400",
                type: "line",
                options: _vm.options,
                series: _vm.series,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "d-flex align-items-center justify-content-center p-1",
            staticStyle: { width: "100%", "min-height": "400px" },
          },
          [_vm._m(0)]
        ),
    _vm._v(" "),
    _c("div", { staticClass: "p-1" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-primary",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.show_filter_options()
            },
          },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.__("globals.filter_options")) +
              "\n            "
          ),
          !_vm.show_filters
            ? _c("i", { staticClass: "feather icon-chevron-down" })
            : _vm._e(),
          _vm._v(" "),
          _vm.show_filters
            ? _c("i", { staticClass: "feather icon-chevron-up" })
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("form", { class: _vm.show_filters ? "p-1" : "p-1 hidden" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "form-group flex-grow-1" }, [
          _c("label", { attrs: { for: "start_date" } }, [
            _vm._v(_vm._s(_vm.__("globals.start_date"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.start_date,
                expression: "start_date",
              },
            ],
            staticClass: "form-control",
            attrs: { id: "start_date", type: "month" },
            domProps: { value: _vm.start_date },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.start_date = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.show_error_message
            ? _c(
                "div",
                {
                  staticClass: "text-left text-danger help-block font-small-1",
                  attrs: { role: "alert" },
                },
                [
                  _c("i", { staticClass: "feather icon-x-circle" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.__("globals.start_end_date_error")) +
                      "\n                 "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group flex-grow-1 ml-1" }, [
          _c("label", { attrs: { for: "end_date" } }, [
            _vm._v(_vm._s(_vm.__("globals.end_date"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.end_date,
                expression: "end_date",
              },
            ],
            staticClass: "form-control",
            attrs: { id: "end_date", type: "month" },
            domProps: { value: _vm.end_date },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.end_date = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "selected_fields" + this._uid } }, [
          _vm._v("Fields"),
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selected_fields,
                expression: "selected_fields",
              },
            ],
            ref: "fieldMultiselect",
            staticClass: "form-control",
            attrs: { id: "selected_fields" + this._uid, multiple: "multiple" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selected_fields = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.default_fields, function (field) {
            return _c("option", { domProps: { value: field } }, [
              _vm._v(_vm._s(field)),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-warning",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.reset()
              },
            },
          },
          [_vm._v(_vm._s(_vm.__("globals.reset")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary ml-1",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.filter()
              },
            },
          },
          [_vm._v(_vm._s(_vm.__("globals.filter")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }